let _showConfirm = null;
let _showAlert = null;

export function _registerDialogFns(confirm, alert) {
    _showConfirm = confirm;
    _showAlert = alert;
}

export function showConfirm(message) {
    if (_showConfirm) return _showConfirm(message);
    return Promise.resolve(window.confirm(message));
}

export function showAlert(message) {
    if (_showAlert) return _showAlert(message);
    window.alert(message);
    return Promise.resolve();
}
